export class CommonUtil {
 
    public static onlyAlphabets(event: KeyboardEvent): boolean {
        const key = event.key
        if (/^[a-zA-Z\s]$/.test(key) ||
            ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight'].includes(key)) {
            return true
        }
        event.preventDefault()
        return false
    }

    public static onlyNumbers(event: KeyboardEvent): boolean {
        const key = event.key
        if (/^[0-9]$/.test(key) ||
            ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight'].includes(key)) {
            return true
        }
        event.preventDefault()
        return false
    }

    public static onlyNumbersAndDash(event: KeyboardEvent): boolean {
        const key = event.key
        if (/^[0-9-]$/.test(key) ||
            ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight'].includes(key)) {
            return true
        }
        event.preventDefault()
        return false
    }

    public static onlyNumbersAndSlash(event: KeyboardEvent): boolean {
        const key = event.key
        if (/^[0-9/]$/.test(key) ||
            ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight'].includes(key)) {
            return true
        }
        event.preventDefault()
        return false
    }
}